/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	BP,
	ISchemaFlowNodeTypeOutputDefinitionMap,
	SCHEMA_CONST_ANY_VALUE_TYPE,
	TGetBlueprintSchemaSpec
} from "@adapptio/lib-blueprint";
import { NODE_OUTPUTS, NODE_OUTPUT_NAMES, NODE_TYPES } from "./BlueprintNode";
import { termsEditor } from "../../terms";

export const BlueprintSetSessionNode = {
	name: NODE_TYPES.SET_SESSION,
	label: "Set session",
	icon: "mdi/account-arrow-down",
	opts: BP.Object({
		label: termsEditor.nodes.common.options.label,
		description: termsEditor.nodes.common.options.description,
		props: {
			userIdentityKey: BP.Prop(
				BP.Any({
					label: termsEditor.nodes.setSession.userIdentityKey.label,
					description: termsEditor.nodes.setSession.userIdentityKey.description,
					defaultType: SCHEMA_CONST_ANY_VALUE_TYPE.STRING
				})
			),
			meta: BP.Prop(
				BP.Map({
					label: termsEditor.nodes.setSession.meta.label,
					description: termsEditor.nodes.setSession.meta.description,
					value: BP.Any({
						label: termsEditor.nodes.setSession.meta.value.label,
						description: termsEditor.nodes.setSession.meta.value.description,
						defaultType: SCHEMA_CONST_ANY_VALUE_TYPE.STRING
					})
				})
			)
		},
		editorOptions: {
			layoutType: "passthrough"
		}
	}),
	editorOptions: {
		displayInPalette: true
	},
	resolveOutputs: (): ISchemaFlowNodeTypeOutputDefinitionMap => ({
		[NODE_OUTPUT_NAMES.ON_SUCCESS]: NODE_OUTPUTS.ON_SUCCESS,
		[NODE_OUTPUT_NAMES.ON_ERROR]: NODE_OUTPUTS.ON_ERROR
	})
};

export type TBlueprintSetSessionNodeOptsSchemaSpec = TGetBlueprintSchemaSpec<
	typeof BlueprintSetSessionNode["opts"]
>;
